import { render, staticRenderFns } from "./PurchasesOrderViewDeliveries.vue?vue&type=template&id=3f768905&scoped=true&"
import script from "./PurchasesOrderViewDeliveries.vue?vue&type=script&lang=js&"
export * from "./PurchasesOrderViewDeliveries.vue?vue&type=script&lang=js&"
import style0 from "./PurchasesOrderViewDeliveries.vue?vue&type=style&index=0&id=3f768905&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f768905",
  null
  
)

export default component.exports